export class PromptMemoizer {
  private memoizedCache: Record<string, unknown> = {};

  memoize(prompt: string, result: unknown) {
    this.memoizedCache[prompt] = result;
  }

  read(prompt: string): unknown {
    return this.memoizedCache[prompt];
  }
}
